<template>
  <b-form-group
    id="date-input"
    :label="dateName"
    label-for="date-input"
    :class="labelClass"
    :invalid-feedback="date.invalidFeedback"
    :state="date.state">
    <vc-date-picker
      ref="date-input"
      v-model="date.value"
      :mode="mode"
      is-dark
      is24hr
      locale="fr"
      color="yellow"
      :max-date="minDate"
      :popover="{ visibility: 'click' }"
      :minute-increment="5"
      :first-day-of-week="2"
      :modelConfig="modelConfig"
      :is-required="isRequired">
      <template v-slot="{ inputValue, inputEvents }">
        <input
          class="border px-2 py-1 rounded date-datepicker"
          :class="{'is-invalid': date.state === false}"
          v-model="dateInput"
          @input="formatDate"
          @keydown.enter="updateDateValue"
          @blur="updateDateValue"
          :placeholder="dateName"
          :required="isRequired"/>
      </template>
    </vc-date-picker>
  </b-form-group>
</template>

<script>
export default {
  name: 'DateField',

  props: {
    indexForm:{
      type:Number,
      default: 0,
    },
    dateName: {
      type: String,
      default: 'Date'
    },
    labelClass: {
      type: String,
      default: 'medium-label mb-3'
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    mode:  {
      type: String,
      default: 'dateTime'
    },
    minDate: {
      type: Date,
      default: () => (new Date())
    },
    modelConfig: {
      type: Object,
      default: () => ({
        type: 'number',
        timeAdjust: '10:00:00'
      })
    },
    initValue: {
      default: null
    }
  },

  data () {
    return {
      date: {
        state: null,
        invalidFeedback: null,
        value: null
      },
      dateInput: ''
    }
  },

  methods: {
    sendInfosToParent() {
      this.$emit(
        'dateInfos',
        this.indexForm,
        this.date.state,
        this.date.invalidFeedback,
        this.date.value
      )
    },

    removeInvalidFeedback() {
      this.date.state = null
    },

    formatDate(event) {
      let input = event.target.value.replace(/\D/g, '').substring(0, 8);
      if (input.length > 2) {
        input = input.substring(0, 2) + '/' + input.substring(2);
      }
      if (input.length > 5) {
        input = input.substring(0, 5) + '/' + input.substring(5);
      }
      this.dateInput = input;

      if (this.dateInput.length === 10) {
        this.updateDateValue();
      }
    },

    updateDateValue() {
      const parts = this.dateInput.split('/');

      if (parts.length !== 3) {
        return;
      }

      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);

      if (isNaN(day) || isNaN(month) || isNaN(year)) {
        return;
      }

      const parsedDate = new Date(year, month, day, 10, 0, 0, 0);
      if (
        parsedDate.getFullYear() !== year ||
        parsedDate.getMonth() !== month ||
        parsedDate.getDate() !== day
      ) {
        return;
      }

      this.date.value = parsedDate;
    }
  },

  watch: {
    'date.value': function () {
      this.sendInfosToParent()
    },
    'initValue': {
      immediate: true,
      handler() {
        if (this.initValue) {
          const date = new Date(this.initValue);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          this.dateInput = `${day}/${month}/${year}`;
          this.date.value = this.initValue;
        }
      }
    },
  }
}
</script>

<style scoped>
.date-datepicker {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  height: calc(1.5em + 0.75rem + 2px);
  border-radius: 0.25rem;
  width: 100%;
}

.date-datepicker.is-invalid {
  border: solid #dc3545 1px !important;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat
}
</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/DateField.vue